import { RelatedRecipe, Recipe } from "./related_recipe";

interface TrendRecipe extends Recipe {
  tsukurepo_count?: number;
}

class TrendRelatedRecipe extends RelatedRecipe {
  private tsukurepoCount?: number;

  constructor(recipe: TrendRecipe, blankLogoSrc: string) {
    super(recipe, blankLogoSrc);
    this.tsukurepoCount = recipe.tsukurepo_count;
  }

  toHtml(): string {
    // HTMLエスケープ処理
    const escapedName = this.escapeHtml(this.name);
    const tsukurepoCountText = this.tsukurepoCount !== undefined
      ? `
      <div class="text-cookpad-gray-600 text-cookpad-12 font-semibold">
        <span class="tsukurepo-tag">つくれぽ</span>
        <span class="text-cookpad-12">${this.tsukurepoCount}件</span>
      </div>`
      : '';

    return `
      <div class="recipe_box">
        <a href="${this.url}" target="_blank">
          <div class="recipe_content">
            <div class="recipe_title">${escapedName}</div>
            <img src="${this.imageUrl}" alt="${escapedName}" />
            ${tsukurepoCountText}
          </div>
        </a>
      </div>
    `;
  }

  private escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}

export { TrendRelatedRecipe };

